import {
  Checkbox as FullCheckbox,
  EmptyCheckbox,
  DisabledCheckbox,
  HalfCheckBox,
  DisableCheckCheckbox,
} from '@randstad-lean-mobile-factory/react-components-ui-shared';
import classnames from 'classnames';

import styles from './Checkbox.module.scss';
import { CheckboxProps } from './Checkbox.types';

export const Checkbox = ({
  label,
  children,
  checked,
  disabled,
  halfChecked,
  ...props
}: CheckboxProps) => (
  <div>
    <label className={styles.label}>
      <input
        type="checkbox"
        role="checkbox"
        style={{ display: 'none' }}
        disabled={disabled}
        checked={checked}
        {...props}
      />

      {!disabled &&
        (checked ? (
          <FullCheckbox />
        ) : halfChecked ? (
          <HalfCheckBox />
        ) : (
          <EmptyCheckbox className={styles.hoveredIcon} />
        ))}
      {disabled && (checked ? <DisableCheckCheckbox /> : <DisabledCheckbox />)}
      {Boolean(label || children) && (
        <div className={classnames(styles.label, { [styles.disabled]: disabled })}>
          {label ?? children}
        </div>
      )}
    </label>
  </div>
);
